<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="32" height="32" rx="16" fill="#2A3243" />
  <path d="M14 20L18 16L14 12" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
